import { useState } from "react";
import { evaluateTask } from "@/modules/common/api/index.v2";
import { TaskAiEvaluationResponse } from "@/modules/common/types";

interface UseTaskAiEvaluationReturn {
  isLoading: boolean;
  evaluateTaskContent: (taskContent: string) => Promise<TaskAiEvaluationResponse | null>;
}

export const useTaskAiEvaluation = (): UseTaskAiEvaluationReturn => {
  const [isLoading, setIsLoading] = useState(false);

  const evaluateTaskContent = async (taskContent: string) => {
    if (!taskContent.trim()) {
      return null;
    }

    setIsLoading(true);

    try {
      const result = await evaluateTask(taskContent);
      // Handle both direct response and wrapped response
      const actualResult = (result as any)?.data || result;
      return actualResult;
    } catch {
      throw new Error("Failed to evaluate task");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    evaluateTaskContent,
  };
};
